import { QueryClient } from 'react-query';
import {
	getAllTeams,
	getRounds,
	getTeams,
	getallNotifiactions,
	getunreadNotifiactions,
	getActivities,
	paramsType,
	getCups,
	getCupKnockouts,
} from './axiosCalls';

export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
		},
	},
});

// ------------------------------------------------------------------------------------------------ //
// Teams System
// !User Teams

export const teamsLoader = async () => {
	return await queryClient.fetchQuery('teams', getTeams, { staleTime: 0 }).then((res) => res);
};

// * on Show more action
export const allTeamsLoader = async () => {
	return await queryClient.fetchQuery('all-teams', getAllTeams, { staleTime: 0 }).then((res) => res);
};

// export const login = async ()=>{
//     const res = await queryClient.fetchQuery('login',Login, {staleTime:10000})
//     return res;
// }

// ------------------------------------------------------------------------------------------------ //
// Notification System

export const allNotificationLoader = async (params?: paramsType) => {
	return await queryClient
		.fetchQuery(
			'allNotifications',
			() => {
				return getallNotifiactions(params);
			},
			{ staleTime: 0 },
		)
		.then((res) => res);
};

export const unreadNotificationLoader = async () => {
	return await queryClient.fetchQuery('unreadNotifications', getunreadNotifiactions, { staleTime: 0 });
};

// ------------------------------------------------------------------------------------------------ //
// !User Rounds  => paginated
export const roundsLoader = async (queries) => {
	return await queryClient
		.fetchQuery(
			`rounds-${queries.state}-${queries.type}-${queries.page}`,
			() => {
				return getRounds(queries);
			},
			{ staleTime: 0 },
		)
		.then((res) => res);
};

// ------------------------------------------------------------------------------------------------ //
// !User Round Activities
export const activitiesLoader = async (slug: string, queries: any) => {
	return await queryClient
		.fetchQuery(`activities-${queries.state}-${queries.type}-${queries.page}`, () => {
			return getActivities(slug, queries);
		})
		.then((res) => res);
};
// ------------------------------------------------------------------------------------------------ //
